// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1uyUS","content":"App_content__1O9U6","sidebar":"App_sidebar__TJ3G-"};